/** Terms and Conditions page for users to read */

import { type GetServerSideProps } from "next";
import Link from "next/link";
import { Layout } from "~/components/Layout/Layout";
import { EventNames } from "~/mixpanel/EventNames";
import { trackEvent } from "~/mixpanel/trackEvent";

const websiteName = "Imam Ibn al-Qayyim's Islamic Public Library";

const Policies = () => (
  <Layout
    title="Policies"
    description="Terms, conditions, and privacy policy for using the Imam Ibn al-Qayyim's Islamic Public Library website"
    imgUrl="/img/new-jersey.jpg"
  >
    <>
      <span>
        Welcome to the {websiteName} website. These Terms of Service{" "}
        {`("Terms")`} govern your use of {websiteName}, which is owned and
        operated by{" "}
        <Link target="_blank" href="https://twitter.com/masjidrahmah">
          Masjid Rahmah
        </Link>
        . By using this website and its services, you agree to be bound by these
        Terms.
      </span>
      <br />
      <ol>
        <li>
          <strong>Use of Website</strong>
          <p>
            You may use this website for your personal use and you agree not to
            use it for any commercial purposes. You may not copy, reproduce,
            distribute, publish, display, perform, modify, or create derivative
            works from any part of this website.
          </p>
        </li>
        <li>
          <strong>Privacy</strong>
          <p>
            We respect your privacy and will not share your personal information
            with any third party, except for the necessary information required
            by our payments platform, Square, to process your payments. This
            includes sharing your name, email address, and payment card with
            Square. We encourage you to review{" "}
            <Link
              target="_blank"
              href="https://squareup.com/us/en/legal/general/privacy"
            >
              {`Square's`} privacy policy
            </Link>{" "}
            for more information on how they handle your personal data if you
            have any questions.
          </p>
        </li>
        <li>
          <strong>Cancellation Policy</strong>
          <p>
            We do not offer refunds for any purchases made on this website. If
            you have any questions about your purchase, please{" "}
            <Link href="contact">contact us</Link>.
          </p>
        </li>
        <li>
          <strong>Links to Other Websites</strong>
          <p>
            This website may contain links to other websites. We are not
            responsible for the content or privacy practices of these websites.
            We encourage you to read the privacy policies of these websites.
          </p>
        </li>
        <li>
          <strong>Changes to Terms</strong>
          <p>
            We reserve the right to change these Terms at any time. We will
            notify you of any changes by posting the new Terms on this page. You
            are advised to review this page periodically for any changes.
          </p>
        </li>
      </ol>
    </>
  </Layout>
);

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  await trackEvent(ctx, EventNames.POLICIES_PAGE_VIEWED);
  return { props: {} };
};
export default Policies;
